var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"block",staticClass:"mpd-resize-block",class:[_vm.position],on:{"mousedown":function($event){$event.stopPropagation();return _vm.mouseDownHandle.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }